// Translation known problems
// # Problem:     If link or other tag occurs during translation it would pass like a string, not html
// # How to deal: Use v-html attribute to put whole html into block, check frontend\webpack-assets\vue\templates\product\catalog\parts\FooterAbout.vue for translatedStep() function
// 

import { createApp } from "vue";
import RenderAlert from "/webpack-assets/vue/components/RenderAlert.vue";
import {socialSharerLoad} from "../../js/parts-custom/sharer-custom.js";

export function renderAlertVue(text, colorClass = "alert-success", duration = 3000) {
  const container = document.createElement("div");
  container.classList.add("render-alert-wrap");
  document.body.appendChild(container);
    
  const app = createApp(RenderAlert, { text, colorClass, duration });
  app.mount(container);
}

export function translate(keyOrParams, messages, ...params) {
    let namespace = 'common';
    let key = keyOrParams;

    if (typeof keyOrParams === 'object' && !Array.isArray(keyOrParams)) {
        const { ns, ...otherParams } = keyOrParams;
        params = [otherParams];
        namespace = ns || 'common';
    } else if (typeof keyOrParams === 'string') {
        key = keyOrParams;
    }

    let translation = messages[namespace] && messages[namespace][key] ? messages[namespace][key] : null;

    if (!translation) {
        for (const ns in messages) {
            if (messages[ns][key]) {
                translation = messages[ns][key];
                break;
            }
        }
    }

    if (!translation) {
        translation = key;
    }

    if (params.length === 1 && typeof params[0] === 'string') {
        params = { 0: params[0] };
    } else if (params.length === 1 && typeof params[0] === 'object') {
        params = params[0];
    }

    Object.keys(params).forEach(param => {
        const regex = new RegExp(`{${param}}`, 'g');
        translation = translation.replace(regex, params[param]);
    });

    return translation;
}

export function loadMessages(language, controllers, additionalControllers) {
    const messages = {};

    try {
        messages['common'] = require(`/webpack-assets/vue/messages/common/${language}/app.json`);
    } catch (e) {
        console.error(`Error loading messages for common in ${language}:`, e);
    }

    if(additionalControllers) {

    }

    const controllerList = Array.isArray(controllers) ? controllers : [controllers];
    controllerList.push(...additionalControllers || []);

    controllerList.forEach(ns => {
        const controllerPath = ns.includes('/') ? ns.split('/')[0] : ns;

        if (controllerPath === 'common') return;

        try {
            messages[ns] = require(`/webpack-assets/vue/messages/${controllerPath}/${language}/app.json`);
        } catch (e) {
            console.error(`Error loading messages for ${controllerPath} in ${language}:`, e);
        }
    });

    return { languages: [language], messages };
}

window.tagTracking = function tagTracking(type, data = false) {

    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({ecommerce: null});

        if (typeof data === 'string') {
            data = JSON.parse(data);
        }

        switch (type) {
            case 'registration':
                dataLayer.push({'event': 'CompleteRegistration'});
                break;
            case 'authorize':
                dataLayer.push({'event': 'Auth'});
                break;
            case 'socialAuth':
                dataLayer.push({'event': 'SocialAuth'});
                break;
            case 'addToCart':
                dataLayer.push({
                    event: "add_to_cart",
                    ecommerce: {
                        items: data
                    }
                });
                break;
            case 'removeFromCart':
                dataLayer.push({
                    event: "remove_from_cart",
                    ecommerce: {
                        items: data
                    }
                });
                break;
            case 'checkout':
                dataLayer.push({
                    event: "begin_checkout",
                    ecommerce: {
                        items: data
                    }
                });
                break;
            case 'viewCart':
                dataLayer.push({
                    event: "view_cart",
                    ecommerce: {
                        items: data
                    }
                });
                break;
            case 'successPurchase':
                dataLayer.push({
                    event: "purchase",
                    ecommerce: data
                });
                break;
            case "viewOffers":
                dataLayer.push({
                    event: "select_item",
                    ecommerce: {
                        items: data
                    }
                });
                break;
            case "viewProducts":
                dataLayer.push({
                    event: "view_item_list",
                    ecommerce: {
                        items: data
                    }
                });
                break;
            case "ConfirmPay":
                dataLayer.push({
                    event: "confirm_pay",
                    ecommerce: {
                        items: data
                    }
                });
                break;
        }
    }
}

document.addEventListener('click', function (e) {
  const el = e.target.closest('[data-tag-tracking]');
  if (!el) return;

  const type = el.getAttribute('data-tag-tracking');
  const info = el.getAttribute('data-info');

  tagTracking(type, info);
});

socialSharerLoad();